import { render, staticRenderFns } from "./Error403.vue?vue&type=template&id=6a674150&"
var script = {}
import style0 from "./Error403.vue?vue&type=style&index=0&id=6a674150&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports